import React from "react";
import { Resource, Title } from "react-admin";
import { Card, CardContent } from "@material-ui/core";

import { useTokenOps } from "../components/TokenContext";
import AccountFeaturesEditor from "./AccountFeaturesEditor";

/**
 * Features and status of the account the admin is switched to. Uses the same
 * editor (and admin endpoint) as Bcome > Features by account.
 */
export const CurrentAccountFeaturesPage = () => {
    const tokenOps = useTokenOps();
    const accountId = tokenOps.account?.data?.accountId;
    return (
        <>
            <Title title="Account features" />
            <Card>
                <CardContent>
                    <AccountFeaturesEditor accountId={accountId} />
                </CardContent>
            </Card>
        </>
    );
};

const accountFeaturesResource = () => <Resource
    name="accountFeatures"
    options={{label: 'Account features', menuGroup: 'Accounts'}}
    list={CurrentAccountFeaturesPage}/>;

export default accountFeaturesResource;
